import { FontIcon } from "@fluentui/react";
import { Tooltip } from "antd";
import { useNavigate } from "react-router";
import { fetchDocuments } from "../../../redux/EngageTranslation/EngageTranslationAction";
// import { getDocumentAuditLog } from "../../../redux/EngageTranslation/EngageTranslationAction";

const AuditPageNavigationButton = ({ id, name }: any) => {
  const navigate = useNavigate();

  return (
    <Tooltip
      placement="bottom"
      title={"Document audit history"}>
      <button
        className="button action"
        onClick={() => {
          navigate(`${id}/audit-log`);
        }}>
        <FontIcon
          // className="icon-action"
          iconName="ComplianceAudit"
        />
      </button>
    </Tooltip>
  );
};

export default AuditPageNavigationButton;
